import React from 'react';
import { DepartmentPerformance } from '../services/dashboardApi';

interface DepartmentPerformanceTableProps {
  data: DepartmentPerformance[];
}

const DepartmentPerformanceTable: React.FC<DepartmentPerformanceTableProps> = ({ data }) => {

  return (
    <div className="card card-flush h-100 shadow-sm">
      <div className="card-header pt-7 pb-3">
        <h3 className="card-title">
          <span className="card-label fw-bold text-gray-800">Department Performance</span>
        </h3>
      </div>
      <div className="card-body pt-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <div className="table-responsive">
          <table className="table table-row-dashed gy-4 align-middle">
            <thead>
              <tr className="fw-bold text-gray-800 bg-light">
                <th className="ps-4 rounded-start">Department</th>
                <th className="pe-4 text-end rounded-end">Highest Completion</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                console.log('s',item),
                <tr key={index}>
                  <td className="ps-4">
                    <span className="text-gray-800 fw-semibold">{item.department}</span>
                  </td>
                  <td className="pe-4 text-end">
                    <span className="badge badge-light-success fw-bold fs-7">
                      {item.highestCompletion}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DepartmentPerformanceTable;
